/*
 * Hero CTA hardening.
 *
 * A global script on the homepage (a) intercepts hero CTA clicks and
 * preventDefaults them so real links do not navigate, (b) does an async
 * scroll-reset so in-page hash scrolling gets undone, and (c) re-renders the
 * hero anchor after load, which orphans any listener bound directly to it.
 *
 * So we delegate on document in the capture phase (survives node replacement)
 * and drive the action ourselves. The interceptor does not stopImmediate-
 * Propagation, so our capture listener still runs. For real URLs we navigate
 * explicitly with location.assign, which overrides the interceptor's
 * preventDefault. For in-page targets we scroll and re-assert it across the
 * next few frames to beat the async reset.
 */
(function () {
  function forceScroll(target) {
    // behavior:'instant' bypasses the theme's html { scroll-behavior: smooth }.
    // The interceptor cancels smooth scroll animations mid-flight, so smooth
    // jumps silently die near the top of the page.
    var go = function () {
      try { target.scrollIntoView({ behavior: 'instant', block: 'start' }); }
      catch (err) { target.scrollIntoView(true); }
    };
    var assertPos = function () {
      if (Math.abs(target.getBoundingClientRect().top) > 120) { go(); }
    };
    go();
    setTimeout(assertPos, 250);
    setTimeout(assertPos, 700);
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.hero-homepage-cta-wrapper a[href]') : null;
    if (!a) { return; }
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#') {
      var id = href.slice(1);
      var target = id && (document.getElementById(id) || document.querySelector('[id="' + id + '"]'));
      if (!target) { return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      forceScroll(target);
      try { history.replaceState(null, '', '#' + id); } catch (err) {}
    } else if (href) {
      e.stopImmediatePropagation();
      window.location.assign(href);
    }
  }, true);
})();
